import React from 'react';

// Translation
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { materialsSlice } from '../MaterialsSlice';

// Gird system
import { Col, Row } from 'react-grid-system';

// Components
import Modal from '../../../components/Modal/Modal';
import {
  InputField,

} from '../../../components/FormElements/FormElements';


import { SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader';
import {
  editMaterialPricingSlice,
  editMaterialPricingState,
} from './EditMaterialPricingSlice';

import { useAPI } from '../../../services/hoc/useAPI';

export default () => {
  // Translation
  const t = useTranslation();

  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { edit_material_pricing: editMaterialPricingState }) =>
      state.edit_material_pricing,
  );
const ENDPOINTS = useAPI()



  const toggle = () => {
    dispatch(editMaterialPricingSlice.actions.setIsOpen(!state.isOpen));
    dispatch(editMaterialPricingSlice.actions.init());
  };

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    dispatch(editMaterialPricingSlice.actions.setIsLoading(true));
    ENDPOINTS.pricing()
      .updateGlassPrices({ prices: state.prices })
      .then((response: any) => {
        if (state.glassPrice != null && state.glassPrice) {
          
       
          let new_prices= response.data.data.filter((ele:any)=>ele.gid ===state.prices[0].glass_id)
        
          dispatch(materialsSlice.actions.updateGlassPrice(new_prices));
        }
        dispatch(editMaterialPricingSlice.actions.setIsLoading(false));
        dispatch(editMaterialPricingSlice.actions.setIsSuccess(true));
        setTimeout(() => {
          toggle();
          dispatch(editMaterialPricingSlice.actions.setIsOpen(false));
        }, 1000);
      });
  };

  return (
    <Modal open={state.isOpen} toggle={toggle}>
      {state.isLoading ? <WhiteboxLoader /> : ''}

      {state.isSuccess ? <SuccessMark /> : ''}

      <h2 className="text-center" style={{ margin: '0 0 20px' }}>
        {t('pricing')}
      </h2>

      <form onSubmit={submit} style={{ width: '450px' }}>
        <div className="attribute">
          <div
            className="attribute-fields"
            style={state.prices.length > 1 ? {} : { padding: 0 }}>
            <Row>
              <Col md={12}>
                <InputField
                  type="number"
                  label={t('price')}
                  step={'.01'}
                  value={state.prices[0].price}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    dispatch(
                      editMaterialPricingSlice.actions.setPriceValue(
                        e.target.value,
                      ),
                    );
                  }}
                />
              </Col>
            </Row>
          </div>
        </div>

        <button
          className="button round bg-gold color-white margin-top-20"
          style={{ padding: '0 80px', marginBottom: 5 }}>
          {t('submit')}
        </button>
      </form>
    </Modal>
  );
};
